module.exports = __webpack_public_path__ + "assets/tick.c45ab3d93a26e5f175e92bb56a4cfe0d.png";


/*****************
 ** WEBPACK FOOTER
 ** ./img/tick.png
 ** module id = 142
 ** module chunks = 0
 **/